/**
 * Formatta il nome completo del cliente.
 * - Se ha ragione_sociale (azienda), usa quella.
 * - Altrimenti combina cognome + nome.
 * @param {Object} customer - Oggetto cliente con campi nome, cognome, ragione_sociale
 * @param {string} fallback - Valore di fallback se nessun nome è disponibile (default: 'N/D')
 * @returns {string}
 */
export const formatCustomerName = (customer, fallback = 'N/D') => {
  if (!customer) return fallback;
  if (customer.ragione_sociale) return customer.ragione_sociale;
  const fullName = `${customer.cognome || ''} ${customer.nome || ''}`.trim();
  return fullName || fallback;
};
